export const FETCH_CONTACT_MEMBERS = 'CONTACT_MEMBERS/FETCH_REQUEST';
export const FETCH_CONTACT_MEMBERS_SUCCESS = 'CONTACT_MEMBERS/FETCH_SUCCESS';

export const OPEN_MODAL_EDIT = 'CONTACT_MEMBERS/EDIT/OPEN';
export const CLOSE_MODAL_EDIT = 'CONTACT_MEMBERS/EDIT/CLOSE';

export const UPDATE_CONTACT_MEMBER = 'CONTACT_MEMBERS/EDIT/UPDATE_REQUEST';
export const UPDATE_CONTACT_MEMBER_SUCCESS = 'CONTACT_MEMBERS/EDIT/UPDATE_SUCCESS';
export const UPDATE_CONTACT_MEMBER_FAILURE = 'CONTACT_MEMBERS/EDIT/UPDATE_FAILURE';

export const DELETE_CONTACT_MEMBERS = 'CONTACT_MEMBERS/DELETE_REQUEST';
export const DELETE_CONTACT_MEMBERS_SUCCESS = 'CONTACT_MEMBERS/DELETE_SUCCESS';
export const DELETE_CONTACT_MEMBERS_FAILURE = 'CONTACT_MEMBERS/DELETE_FAILURE';

/** CONTACT_MEMBERS FILTERS */
export const SET_CONTACT_MEMBERS_FILTER = 'CONTACT_MEMBERS/FILTERS/SET_ONE';
export const SET_CONTACT_MEMBERS_FILTERS = 'CONTACT_MEMBERS/FILTERS/SET_MANY';
export const REMOVE_CONTACT_MEMBERS_FILTER = 'CONTACT_MEMBERS/FILTERS/REMOVE_ONE';
export const CLEAR_CONTACT_MEMBERS_FILTER = 'CONTACT_MEMBERS/FILTERS/CLEAR';
